module.exports = __webpack_public_path__ + "img/profile2.986ee0cc.png";